import * as yup from 'yup'

const useSchema = (schema: any) => {
  const combinedSchema = schema.shape({
    baseError: yup.string().default(''),
  })

  return toTypedSchema(combinedSchema)
}

export default useSchema
